/* tslint:disable */
/* eslint-disable */
export enum WorkDocxTemplateNameEnum {
  DsAbnahmeprotokoll = 'DS_ABNAHMEPROTOKOLL',
  DsBaudossier = 'DS_BAUDOSSIER',
  DsBestellung = 'DS_BESTELLUNG',
  DsBestellung202503 = 'DS_BESTELLUNG_202503',
  DsObTerminbestaetigung = 'DS_OB_TERMINBESTAETIGUNG',
  DsOfferte = 'DS_OFFERTE',
  DsOfferte202503 = 'DS_OFFERTE_202503',
  DsProjektPlanungsformular = 'DS_PROJEKT_PLANUNGSFORMULAR',
  DsSchlussrechnung = 'DS_SCHLUSSRECHNUNG',
  DsSchlussrechnung202503 = 'DS_SCHLUSSRECHNUNG_202503',
  GeneralAppAccessCode = 'GENERAL_APP_ACCESS_CODE',
  GeneralAuftragKernbohrung = 'GENERAL_AUFTRAG_KERNBOHRUNG',
  GeneralBegleitbriefSpeicherbroschuere = 'GENERAL_BEGLEITBRIEF_SPEICHERBROSCHUERE',
  GeneralBestellungAenderung = 'GENERAL_BESTELLUNG_AENDERUNG',
  GeneralChecklisteBaustelle = 'GENERAL_CHECKLISTE_BAUSTELLE',
  GeneralDebitor = 'GENERAL_DEBITOR',
  GeneralDebitorKleivVorfinanzierung = 'GENERAL_DEBITOR_KLEIV_VORFINANZIERUNG',
  GeneralElektroInfos = 'GENERAL_ELEKTRO_INFOS',
  GeneralGebaeudeprogrammAbschlussBegleitschreibenKunde = 'GENERAL_GEBAEUDEPROGRAMM_ABSCHLUSS_BEGLEITSCHREIBEN_KUNDE',
  GeneralGebaeudeprogrammAbschlussBegleitschreibenVollzugsstelle = 'GENERAL_GEBAEUDEPROGRAMM_ABSCHLUSS_BEGLEITSCHREIBEN_VOLLZUGSSTELLE',
  GeneralGebaeudeprogrammGesuchBegleitschreibenKunde = 'GENERAL_GEBAEUDEPROGRAMM_GESUCH_BEGLEITSCHREIBEN_KUNDE',
  GeneralGebaeudeprogrammGesuchBegleitschreibenVollzugsstelle = 'GENERAL_GEBAEUDEPROGRAMM_GESUCH_BEGLEITSCHREIBEN_VOLLZUGSSTELLE',
  GeneralGutschrift = 'GENERAL_GUTSCHRIFT',
  GeneralNachbarschaftskarte = 'GENERAL_NACHBARSCHAFTSKARTE',
  GeneralObNichtErreicht = 'GENERAL_OB_NICHT_ERREICHT',
  GeneralProvonoFehlendeUnterschriftVollmacht = 'GENERAL_PROVONO_FEHLENDE_UNTERSCHRIFT_VOLLMACHT',
  GeneralProvonoFehlendeUnterschriftZession = 'GENERAL_PROVONO_FEHLENDE_UNTERSCHRIFT_ZESSION',
  GeneralProvonoFehlendeUnterschriften = 'GENERAL_PROVONO_FEHLENDE_UNTERSCHRIFTEN',
  GutschriftWeiterempfehlung = 'GUTSCHRIFT_WEITEREMPFEHLUNG',
  KaBestellung = 'KA_BESTELLUNG',
  KaBestellung202503 = 'KA_BESTELLUNG_202503',
  KaObTerminbestaetigung = 'KA_OB_TERMINBESTAETIGUNG',
  KaOfferte = 'KA_OFFERTE',
  KaOfferte202503 = 'KA_OFFERTE_202503',
  KaProjektPlanungsformular = 'KA_PROJEKT_PLANUNGSFORMULAR',
  KreditorProjektNummern = 'KREDITOR_PROJEKT_NUMMERN',
  PvAbnahmeprotokoll = 'PV_ABNAHMEPROTOKOLL',
  PvAbschlussrechnung = 'PV_ABSCHLUSSRECHNUNG',
  PvBaudossier = 'PV_BAUDOSSIER',
  PvBeglaubigungPrimeo = 'PV_BEGLAUBIGUNG_PRIMEO',
  PvBegleitbriefAnlagendokumentation = 'PV_BEGLEITBRIEF_ANLAGENDOKUMENTATION',
  PvBestellung = 'PV_BESTELLUNG',
  PvChecklisteTob = 'PV_CHECKLISTE_TOB',
  PvDsObTerminbestaetigung = 'PV_DS_OB_TERMINBESTAETIGUNG',
  PvKalkulationMitPreise = 'PV_KALKULATION_MIT_PREISE',
  PvKalkulationOhnePreise = 'PV_KALKULATION_OHNE_PREISE',
  PvMeldungGebaeudeversicherung = 'PV_MELDUNG_GEBAEUDEVERSICHERUNG',
  PvObTerminbestaetigung = 'PV_OB_TERMINBESTAETIGUNG',
  PvOfferte = 'PV_OFFERTE',
  PvProjektPlanungsformular = 'PV_PROJEKT_PLANUNGSFORMULAR',
  SelfserviceOfferte = 'SELFSERVICE_OFFERTE',
  WpAbschlussrechnung = 'WP_ABSCHLUSSRECHNUNG',
  WpBestellung = 'WP_BESTELLUNG',
  WpChecklisteTob = 'WP_CHECKLISTE_TOB',
  WpObTerminbestaetigung = 'WP_OB_TERMINBESTAETIGUNG',
  WpOfferte = 'WP_OFFERTE',
  WpProjektPlanungsformular = 'WP_PROJEKT_PLANUNGSFORMULAR',
  WpAbnahmeprotokoll = 'WP_ABNAHMEPROTOKOLL'
}
